<script setup lang="ts">
import { type SidebarBrandProps } from "../protocols";
const props = defineProps<SidebarBrandProps>();
</script>
<template>
  <NuxtLink :to="props.to">
    <img preload :src="props.src" width="100" height="24" alt="" />
  </NuxtLink>
</template>
